module.exports = __webpack_public_path__ + "img/turbo-features13.021e3294.png";